import React, { useContext } from 'react';
import Modal from '@mui/material/Modal';

import './content-modal-style.scss';
import { DeviceContext, deviceType } from '@providers';

import Typography from '@src/componentsNew/Typography/Typography';
import CloseIcon from '@src/componentsNew/Icons/Icons/CloseIcon';

interface IProps {
  open?: boolean;
  onClose?: () => void;
  title?: string;
  showCloseIcon?: boolean;
  children: React.ReactNode;
}

const ContentModal: React.FC<IProps> = ({ open, onClose, title, showCloseIcon, children }: IProps) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    <Modal id="content-modal-wrapper" open={open} onClose={onClose} onClick={(e) => e.stopPropagation()}>
      <div className={`content-modal-content ${isMobile ? 'mobile' : ''}`}>
        {title || showCloseIcon ? (
          <div className={`content-modal-title-area ${showCloseIcon ? 'between' : ''}`}>
            <Typography cName="title-text" variant="subtitle1" component="h4" style={{ color: '#212121' }}>
              {title}
            </Typography>

            {showCloseIcon && <CloseIcon cName="close-btn" onClick={onClose} />}
          </div>
        ) : null}

        {children}
      </div>
    </Modal>
  );
};

export default ContentModal;
